module.exports = __webpack_public_path__ + "static/media/180.001aff42.png";


//////////////////
// WEBPACK FOOTER
// ./src/180.png
// module id = 475
// module chunks = 0